import React from "react"

const NoStoreAvailable = props => {
  const { staticTexts, error, isServiceLocator } = props
  return (
    <>
      <div>
        <div className="find-a-store__horizontal-line" />
        <div className="find-a-store__no-store-text">
          {error ??
            (isServiceLocator
              ? staticTexts?.selectStateMessage
              : staticTexts?.selectDropdown)}
        </div>
      </div>
    </>
  )
}

export default NoStoreAvailable
